import { loadClinicalNoteAuthority } from '@/services/clinicalNoteAuthority';
import { supabase } from '@/services/supabaseClient';
const unwrap = ({data,error}) => { if(error) throw error; return data; };
export async function clinicalRpc(name,args){return unwrap(await supabase.rpc(`afrimed_${name}`,args));}
export async function loadClinicalAction(id){return unwrap(await supabase.from('clinical_actions').select('*').eq('id',id).single());}
export async function loadClinicalRecords(appointmentId){
 const tables=['clinical_actions','clinical_action_versions','clinical_lab_results','clinical_lab_orders','clinical_exchange_consents','clinical_exchanges','clinical_gateway_endpoints'];
 const values=await Promise.all(tables.map(async table=>{
  let q=supabase.from(table).select('*');
  if(appointmentId&&['clinical_actions','clinical_action_versions'].includes(table))q=q.eq('appointment_id',appointmentId);
  return unwrap(await q);
 }));
 const out=Object.fromEntries(tables.map((table,i)=>[table,values[i]||[]]));
 const versions=new Set(out.clinical_action_versions.map(v=>v.id));
 for(const table of ['clinical_lab_results','clinical_lab_orders','clinical_exchange_consents','clinical_exchanges'])out[table]=out[table].filter(row=>versions.has(row.version_id));
 return out;
}
export async function finalisedClinicalSource(appointmentId){return (await loadClinicalNoteAuthority(appointmentId)).final_report;}
export async function processMockLab(exchangeId){return unwrap(await supabase.functions.invoke('clinical-exchange',{body:{exchange_id:exchangeId}}));}
